const createQuery = () => `
  ... on EventLatestCTA {
    id
    event {
      startDate
      endDate
      lightLogoUrl
      darkLogoUrl
      _fullUrl
      city
      brandColor
      backgroundVideoId
    }
    backgroundURL
    textOverride
    videoId
  }
`
export default createQuery
